import React, { useState } from "react";
import Header from "../components/Header";
import "../css/Main.css";
import webDev from "../images/WebDev.png";
import Marketing from "../images/Marketing.jpg";
import AIML from "../images/AIML.jpg";
import DevOps from "../images/DevOps.jpg";
import VR from "../images/VR.jpg";
import IT from "../images/IT.jpg";
import CRM from "../images/CRM.jpg";
import App from "../images/App.jpg";
import Game from "../images/Game.jpg";
import Blockchain from "../images/blockchain.jpg";
import GraphicDesign from "../images/GraphicDesign.jpg";
import ITMarketing from "../images/ITMarketing.jpg";
import ITsupportMaintain from "../images/ITsupportMaintain.jpg";
import BlockChainNFT from "../images/BlockChainNFT.jpg";
import WebARVR from "../images/WebARVR.jpg";
import WebDesignandDev from "../images/WebDesignandDev.jpg";
import MobileAppDev from "../images/MobileAppDev.jpg";
import SoftwareasService from "../images/SoftwareasService.jpg";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

function Main() {
  const [hoveredBox, setHoveredBox] = useState(null);

  const Navigate = useNavigate();

  const handleWebDNavigation = (path) => {
    Navigate(path);
  };

  const services = [
    {
      id: 1,
      default: "Web Design & Development",
      hover:
        "Our web design and development services focus on creating visually appealing, responsive, and user-friendly websites tailored to your specific needs. We ensure seamless navigation and a strong online presence.",
      defaultIcon: <img className="WebDev-icon" alt="" src={webDev} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={webDev} />,
      onClick: () => handleWebDNavigation("/webD"),
    },
    {
      id: 2,
      default: "AI & ML",
      hover:
        "Unlock the potential of Artificial Intelligence and Machine Learning with our innovative solutions. We help businesses automate processes, gain insights from data, and enhance decision-making.",
      defaultIcon: <img className="WebDev-icon" alt="" src={AIML} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={AIML} />,
      onClick: () => handleWebDNavigation("/AIML"),
    },
    {
      id: 3,
      default: "Digital Marketing",
      hover:
        "Expand your reach with our strategic digital marketing services. From content creation to SEO optimization, we ensure your brand connects with the right audience.",
      defaultIcon: <img className="WebDev-icon" alt="" src={Marketing} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={Marketing} />,
      onClick: () => handleWebDNavigation("/DigitalMarketing"),
    },
    {
      id: 4,
      default: "Blockchain & NFT",
      hover:
        "Empower your business with cutting-edge blockchain and NFT solutions. We provide secure, transparent, and innovative services to help you stay ahead in the digital world.",
      defaultIcon: <img className="WebDev-icon" alt="" src={Blockchain} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={Blockchain} />,
      onClick: () => handleWebDNavigation("/Blockchain&NFT"),
    },
    {
      id: 5,
      default: "Game Development",
      hover:
        "Unleash immersive gaming experiences with our cutting-edge game development solutions. From concept to launch, we bring your vision to life with stunning visuals, engaging mechanics, and seamless performance.",
      defaultIcon: <img className="WebDev-icon" alt="" src={Game} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={Game} />,
      onClick: () => handleWebDNavigation("/GameD"),
    },
    {
      id: 6,
      default: "App Development",
      hover:
        "We create feature-rich and user-friendly mobile applications tailored to your business needs, ensuring a seamless user experience across platforms.",
      defaultIcon: <img className="WebDev-icon" alt="" src={App} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={App} />,
      onClick: () => handleWebDNavigation("/AppD"),
    },
    {
      id: 7,
      default: "Web AR & VR",
      hover:
        "Immerse your audience with our Web AR and VR solutions. We bring innovative and interactive experiences to the digital space, enhancing user engagement.",
      defaultIcon: <img className="WebDev-icon" alt="" src={VR} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={VR} />,
      onClick: () => handleWebDNavigation("/ARVR"),
    },
    {
      id: 8,
      default: "CRM & ERP",
      hover:
        "Streamline your business processes with our advanced CRM and ERP systems. We provide integrated solutions to manage resources, customer relationships, and operations effectively.",
      defaultIcon: <img className="WebDev-icon" alt="" src={CRM} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={CRM} />,
      onClick: () => handleWebDNavigation("/crm"),
    },
    {
      id: 9,
      default: "DevOps",
      hover:
        "Optimize your development and operations workflows with our DevOps solutions. We ensure continuous delivery, integration, and deployment for better productivity.",
      defaultIcon: <img className="WebDev-icon" alt="" src={DevOps} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={DevOps} />,
      onClick: () => handleWebDNavigation("/DevOps"),
    },
    {
      id: 10,
      default: "IT Maintenance",
      hover:
        "Our IT maintenance services ensure your systems are always up and running. We provide proactive monitoring, troubleshooting, and support for uninterrupted business operations.",
      defaultIcon: <img className="WebDev-icon" alt="" src={IT} />,
      hoverIcon: <img className="WebDev-icon" alt="" src={IT} />,
      onClick: () => handleWebDNavigation("/SupportMaintainence"),
    },
  ];

  return (
    <>
      <Header />
      <div className="Main">
        <div className="Main-info">
          <div className="Main-info1">
            <p className="Main-p">Your Vision, Our Innovation</p>
            <p className="Main-p1">
              Our expert web developers design seamless, one-of-a-kind
              applications tailored to your needs. Experience exceptional
              quality, a highly personalized touch, and an intuitive interface
              that elevates your digital presence.
            </p>
            <div className="Main-info1-btns">
              <button className="Main-info1-btn1">Success Journeys</button>
              <button
  className="Main-info1-btn2"
  onClick={() =>
    window.open(
      "https://wa.me/917891266745?text=Hello,%20I%20want%20to%20get%20in%20touch",
      "_blank"
    )
  }
>
  Get In Touch
</button>
            </div>
          </div>
          <div className="Main-info2">
            <div className="Main-info2-wrapper">
              <img className="Main-info2-img" src={GraphicDesign} alt="" />
              <img className="Main-info2-img" src={ITMarketing} alt="" />
              <img className="Main-info2-img" src={ITsupportMaintain} alt="" />
              <img className="Main-info2-img" src={BlockChainNFT} alt="" />
              <img className="Main-info2-img" src={WebARVR} alt="" />
              <img className="Main-info2-img" src={WebDesignandDev} alt="" />
              <img className="Main-info2-img" src={MobileAppDev} alt="" />
              <img className="Main-info2-img" src={SoftwareasService} alt="" />
            </div>
          </div>
        </div>
        <div className="Main-services">
          <p className="Main-p2">CORE SERVICES</p>
          <div className="Main-service" >
            {services.map((service) => (
              <div
                key={service.id}
                className="Main-servicebox"
                style={{
                  backgroundColor: service.id % 2 === 0 ? "#D6E4FF" : "#6C8EA1",
                  color: service.id % 2 === 0 ? "#33415c" : "#fff",
                }}
                onMouseEnter={() => setHoveredBox(service.id)}
                onMouseLeave={() => setHoveredBox(null)}
                onClick={service.onClick}
              >
                {hoveredBox === service.id ? (
                  <div>
                    <span className="Main-serviceicon">
                      {service.hoverIcon}
                    </span>
                    <p className="Main-p4">{service.hover}</p>
                    <button className="Main-service-btn">Know More</button>
                  </div>
                ) : (
                  <div>
                    <span className="Main-serviceicon1">
                      {service.defaultIcon}
                    </span>
                    <p className="Main-p3">{service.default}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="Main-reviews">
          <div className="Main-review">
            <i
              class="fa-solid fa-face-smile fa-2xl"
              style={{
                marginTop: "16px",
                marginRight: "10px",
                color: "rgb(255, 255, 255)",
              }}
            ></i>
            <div className="Main-review-text">
              <p style={{ fontSize: "46px" }}>1500+</p>
              <p>Success Clients</p>
            </div>
          </div>
          <div className="Main-review">
            <i
              class="fa-solid fa-database fa-2xl"
              style={{
                marginTop: "16px",
                marginRight: "10px",
                color: "rgb(255, 255, 255)",
              }}
            ></i>
            <div className="Main-review-text">
              <p style={{ fontSize: "46px" }}>1750+</p>
              <p>Projects Delivered</p>
            </div>
          </div>
          <div className="Main-review">
            <i
              class="fa-solid fa-users-gear fa-2xl"
              style={{
                marginTop: "16px",
                marginRight: "10px",
                color: "rgb(255, 255, 255)",
              }}
            ></i>
            <div className="Main-review-text">
              <p style={{ fontSize: "46px" }}>50+</p>
              <p>Full Time Employees</p>
            </div>
          </div>
          <div className="Main-review">
            <i
              className="fa-solid fa-list-check fa-2xl"
              style={{
                marginTop: "16px",
                marginRight: "10px",
                color: "rgb(255, 255, 255)",
              }}
            ></i>
            <div className="Main-review-text">
              <p style={{ fontSize: "46px" }}>12+</p>
              <p>Years in Business</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Main;
